var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-select',_vm._b({attrs:{"value":_vm.$attrs.value,"items":_setup.standardReferencePeriods,"item-text":"label","return-object":"","label":_vm.$t('label'),"prepend-icon":"mdi-calendar","outlined":"","dense":"","clearable":""},on:{"input":(val) => _vm.$emit('input', val)}},'v-select',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }